export default __webpack_public_path__ + "static/media/apple_fi.4f7e7ef3.png";